import { ShopsService } from '../../services'

export const getShopById = (id) => {
    return ShopsService.getRef(id)
        .get()
        .then((doc) => {
            return {
                ...doc.data(),
                id: doc.id
            }
        })
        .catch(e => console.log(e))  
}

export const getShopsByIds = async (ids, size) => {
    const shops = await ShopsService.getShopsByIds(ids, size)
    return shops.data.hits.hits.map(item => item._source)
}

export const getUserShops = (uid) => {
    return ShopsService.getUserShops(uid)
        .get()
        .then((doc) => {
            return doc.docs.map(shop => ({
                    ...shop.data(),
                    id: shop.id
                })
            )
        })
}

export const getShopsList = (userId, filters, page, shopCategory, randomSeed) => {
    const noFilters = filters.alexaRankOrder === null && !filters.monthlySales.length && !filters.category.length
    return ShopsService.getShopsList(userId, filters, page, shopCategory, randomSeed)
        .then(res => res.data)
        .then( data =>  {

            const result = {
                hits: data.hits.hits.map(
                    (entry) => entry._source
                ),
                totalShops: data.hits.total.value
            }

            if(noFilters) {
                result.hits = result.hits.sort(item => item.category === shopCategory ? -1 : 1)
            }

            return result
        })
        .catch(e => {
            console.log(e)
            console.log('error loading search results')
        })
}